module.exports = __webpack_public_path__ + "img/trace_default.5cca1156.png";